export default __webpack_public_path__ + "static/media/person_key.6698064b.csv";